export const ScheduleItemType = {
  SHIFT: 'shift',
  OPEN_SHIFT: 'openShift',
  AVAILABILITY: 'availability',
};
